import {
  MockMap,
} from '@ama-sdk/core';
import {
  Journey,
  JourneyElementCommon,
} from '@dapi/sdk';
import {
  AcceptanceRepository,
  BaggageRepository,
  BoardingPassDataRepository,
  combineBoardingPassResults,
  combineCheckInBaggagePolicies,
  combineJourneys,
  combineJourneyTravelers,
  ContextualSeatmapDataRepository,
  createBoardingPassData,
  createCheckInFlight,
  createJourney,
  createMockData,
  createMockDataWithResponse,
  JourneyTravelerRepository,
  RecursivePartial,
  RegulatoryDetailsReplyDataRepository,
} from '@dapi/sdk/spec';
import {
  contactEmail,
  contactPhone,
  namedTraveler,
} from '../../mock/dictionaries';

const journeyTemplate: RecursivePartial<Journey> = {
  travelers: combineJourneyTravelers([JourneyTravelerRepository.MAN, JourneyTravelerRepository.WOMAN], {}).items,
  contacts: [contactEmail, contactPhone]
};

const mockFlight1 = createCheckInFlight({
  template: {
    id: 'CHECK-IN-FLIGHT-0-MOCK',
    departure: {
      locationCode: 'NCE'
    },
    arrival: {
      locationCode: 'LHR'
    },
    acceptanceStatus: 'opened'
  }
});

const notificationContact = [{
  ...contactEmail,
  purpose: 'notification',
  travelerIds: ['JOURNEY-TRAVELER-0-MOCK']
}, {
  ...contactPhone,
  purpose: 'notification'
},
{
  ...contactEmail,
  purpose: 'notification',
  travelerIds: ['JOURNEY-TRAVELER-1-MOCK']
},
{
  ...contactPhone,
  purpose: 'notification'
}];

const journeys = combineJourneys([{
  ...journeyTemplate,
  contacts: notificationContact
}]).items;

const journeyElementIds = journeys[0].journeyElements.map((je: JourneyElementCommon) => je.id);
const emptyAdditionalNote = combineBoardingPassResults([{
  boardingPassData: BoardingPassDataRepository.DEFAULT
}], {
  journeyElementIds
}).items;
const withAdditionalNote = combineBoardingPassResults([
  {
    boardingPassData: createBoardingPassData({
      template: {
        traveler: journeys[0].travelers[0],
        priorities: {
          isFastTrack: true,
          fastTrackText: 'Sky Priority J Class'
        }
      }
    })
  },
  {
    boardingPassData: createBoardingPassData({
      template: {
        traveler: journeys[0].travelers[1],
        priorities: {
          isFastTrack: true,
          fastTrackText: 'Sky Priority F Class'
        }
      }
    })
  }], {
  journeyElementIds
}).items;

export const additionalNoteSection: MockMap = {
  generateBoardingPasses: [
    createMockDataWithResponse(emptyAdditionalNote, 201),
    createMockDataWithResponse(withAdditionalNote, 201)
  ],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies().items)],
  getJourneyUnpaidItems: [createMockDataWithResponse(undefined, 404, [{
    code: '10000',
    title: 'No unpaid service',
    type: 'error',
    id: '10000'
  }])],
  getRegulatoryDetails: [createMockData(RegulatoryDetailsReplyDataRepository.DEFAULT)],
  requestAcceptanceOfJourney: [createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201), createMockDataWithResponse(AcceptanceRepository.ACCEPTED, 201)],
  retrieveJourneyBaggages: [createMockData([BaggageRepository.DEFAULT])],
  retrieveJourneys: [
    createMockDataWithResponse(journeys, 201),
    createMockDataWithResponse([
      createJourney({
        template: {
          ...journeys[0],
          acceptance: AcceptanceRepository.ACCEPTED
        }
      })
    ], 201)
  ],
  retrieveJourney: [
    createMockData(
      createJourney({
        template: {
          ...journeys[0],
          acceptance: AcceptanceRepository.ACCEPTED
        }
      })
    ), createMockData(
      createJourney({
        template: {
          ...journeys[0],
          acceptance: {
            isAccepted: false,
            isPartial: false,
            isVoluntaryDeniedBoarding: false,
            notCheckedInJourneyElements: [
              {
                id: 'JOURNEY-ELEMENT-0-MOCK',
                journeyElement: {
                  id: 'JOURNEY-ELEMENT-0-MOCK',
                  travelerId: 'JOURNEY-TRAVELER-0-MOCK',
                  flightId: 'CHECK-IN-FLIGHT-0-MOCK',
                  acceptanceEligibility: {
                    status: 'eligible',
                    reasons: []
                  },
                  checkInStatus: 'notAccepted',
                  boardingPassEligibility: {
                    status: 'ineligible'
                  },
                  traveler: namedTraveler,
                  flight: mockFlight1
                }
              },
              {
                id: 'JOURNEY-ELEMENT-1-MOCK',
                journeyElement: {
                  id: 'JOURNEY-ELEMENT-1-MOCK',
                  travelerId: 'JOURNEY-TRAVELER-1-MOCK',
                  flightId: 'CHECK-IN-FLIGHT-0-MOCK',
                  acceptanceEligibility: {
                    status: 'eligible',
                    reasons: []
                  },
                  checkInStatus: 'notAccepted',
                  boardingPassEligibility: {
                    status: 'ineligible'
                  },
                  traveler: namedTraveler,
                  flight: mockFlight1
                }
              }

            ]
          }
        }
      })
    )
  ],
  addContactsToJourney: [
    createMockData([{
      ...contactEmail,
      address: 'toto@free.fr',
      purpose: 'notification',
      travelerIds: ['JOURNEY-TRAVELER-0-MOCK']
    },
    {
      ...contactPhone,
      purpose: 'notification',
      countryPhoneExtension: '33',
      number: '0623456789',
      travelerIds: ['JOURNEY-TRAVELER-0-MOCK']
    },
    {
      ...contactEmail,
      address: 'tata@free.fr',
      purpose: 'notification',
      travelerIds: ['JOURNEY-TRAVELER-1-MOCK']
    },
    {
      ...contactPhone,
      purpose: 'notification',
      countryPhoneExtension: '33',
      number: '0623456781',
      travelerIds: ['JOURNEY-TRAVELER-1-MOCK']
    }
    ])
  ],
  deleteAcceptanceFromJourney: [createMockDataWithResponse({}, 204)],
  retrieveSeatMapsJourneyDriven: [createMockData(ContextualSeatmapDataRepository.DEFAULT)]
};
